import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Fleet } from "@/components/Fleet";
import { Bento } from "@/components/Bento";
import { Services } from "@/components/Services";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Fleet />
      <Bento />
      <Services />
      <QuoteForm />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
